import React from 'react';
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import NavBrand from '../../common/nav-brand'

const Header = () => {
    return (
        <NavBrand to={CLIENT_ENDPOINTS.ROOT} />
    )
}

export default Header
